import { createApp } from 'vue';
import PostArtwork from '../components/post-artwork/PostArtwork';

function postArtwork(opts) {
  const config = {
    dom: {
      parent: 'gallery',
      cell: 'js-post-artwork-image',
    },
    cls: {
      loading: 'is-loading',
    },
  };

  const c = __.extend(config, opts);

  // Global Variables
  const $parent = document.getElementById(c.dom.parent);

  function init() {
    const $cells = $parent?.querySelectorAll(`.${c.dom.cell}`);
    if (!$cells.length) return;

    [...$cells].forEach(($cell) => {
      const {
        framespecEligible,
        handle,
        type,
        variant,
        variantSpec,
        productId,
      } = $cell.dataset;

      // eslint-disable-next-line no-underscore-dangle
      const isMounted = $cell?.__vue_app__ || false;

      if (isMounted) return;

      const id = $cell?.id || null;
      if (!framespecEligible) return;

      if (id) {
        const variantId = id.split('-')[1];
        const numericProductId = Number(productId);
        const app = createApp(PostArtwork, {
          handle,
          productId: numericProductId,
          title: variant,
          type,
          variantSpec,
          variantId,
        });

        app.config.globalProperties.$config = {
          joineryHost: SDG.Data.joineryHost || 'https://staging.framebridge.com',
        };
        const postArtworkImageId = `#${$cell.id}`;
        app.mount(postArtworkImageId);
      }

      __.removeClass($cell, c.cls.loading);
    });
  }

  return init();
}

export default postArtwork;
